import React from "react";
import ReactExport from "react-export-excel";
import { Modal, message, Button, Input, Icon } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserEdit, faUserTimes, faUserTie, faEnvelopeSquare, faFileExcel } from '@fortawesome/free-solid-svg-icons';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let state, data = [];



class Download extends React.Component {

    constructor(props){
        super(props);

        state = this;        

        this.state = {
            dataSet1 : this.props.data,
            update_data: true
        };

       

    }


    render() {

        

        return (
            <ExcelFile element={<Button type="primary" shape="round" size="large"><FontAwesomeIcon className="icon_excel" icon={faFileExcel} /></Button>}>
            <ExcelSheet data={this.props.data} name="Representantes de Comités">
                <ExcelColumn label="Nombre" value="nombre"/>
                <ExcelColumn label="Correo" value="correo"/>
                <ExcelColumn label="Teléfono" value="telefono"/>
                <ExcelColumn label="Comité" value="comite"/>
                <ExcelColumn label="Empresa" value="empresa"/>
            </ExcelSheet>
            
        </ExcelFile>
        );
    }
}

export default Download;
